/*
 * @Description: 资金管理
 * @Author: gao shuai
 * @Date: 2020-04-25 09:26:10
 * @LastEditTime: 2020-06-04 15:28:05
 * @LastEditors: gao shuai
 */

import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  /* ----------------------1.资金管理------------------------ */
  // 资金列表
  async moneylist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetBankPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 更改资金商户状态
  async moneystate(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/ChangeActived',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 通道收款详情
  async moneydetail(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetManagerMerchantBankProductType',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* ----------------------2.T+0 结算------------------------ */
  // T+0列表
  async tzerolist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetBankT0PageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取T+0统计
  async tzeroStaic(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetBankT0Total',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取T+0结算提交
  async tzeroMoney(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/SubmitT0Settlement',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* ----------------------3.T+1 结算------------------------ */
  // T+1列表
  async tonelist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetBankT1PageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取T+1统计
  async toneStaic(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetBankT1Total',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取T+1结算提交
  async toneMoney(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/SubmitT1Settlement',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* ----------------------4.等待审核------------------------ */
  // 等待审核列表
  async auditlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetAuditWithdrawPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取待审核列表统计
  async auditStaic(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetAuditWithdrawTotal',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 审核通过和驳回
  async auditWidthdraw(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/AuditWidthdraw',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* ----------------------5.等待付款------------------------ */
  // 获取待付款列表
  async paylist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetPayWithdrawPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取代付款列表统计
  async payStaic(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GettPayWithdrawTotal',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 付款或驳回结算付款
  async payWidthdraw(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/PayWidthdraw',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* ----------------------6.批复记录------------------------ */
  // 批复记录列表
  async replylist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetSettlementReplyPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 批复管理员列表
  async replyUser(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetReplyUserList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 批复统计信息
  async replyStatic(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetSettlementReplyTotalAmount',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 批复通过和驳回
  async replyWidthdraw(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/ReplyWidthdraw',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 批复详情列表
  async replyDetailList(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetReplyPayWithdrawPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 批复通过和驳回
  async dialogWidthdraw(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/ReplyListPayWidthdraw',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* ----------------------7.结算记录------------------------ */
  // 结算记录列表
  async settleList(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetSettlementPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 结算记录统计
  async settleStatic(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetSettlementTotal',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 清除结算记录
  async clearRecod(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/ClearSettlement',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取网关信息
  async GetGalleryInfo() {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/GetGalleryInfo',
      method: 'get',
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 申请代付
  async ApplyPaid(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageBank/ApplyPaid',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  }
};
